import Component from "@ember/component"
import { action, get, set } from "@ember/object"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import ObjectProxy from "@ember/object/proxy"
import { inject as service } from "@ember/service"
import _ from "lodash"

class ObjectPromiseProxy extends ObjectProxy.extend(PromiseProxyMixin) {}

export default class AdminUserActionsMenu extends Component {
  @service("ember-store") store
  @service socket
  @service rpc
  @service session
  @service notifier

  @action
  impersonate() {
    let newLocation = `${window.location.origin}/users/${get(this, "model.id")}`
    get(this, "session").impersonateUserId(get(this, "model.id"), newLocation)
  }

  @action
  createGraphQLKey() {
    this.rpc.user_admin_create_graphql_key({ userId: get(this, "model.id") }).then((response) => {
      if (response.responseOk) {
        swal({
          type: "success",
          title: "Here is your GraphQL API key!",
          text:
            'Use it as the token in your "Authorization: Bearer &lt;token&gt;" header.\n\n' +
            response.result.token,
        })
      }
    })
    set(this, "canShowActionMenu", false)
  }

  @action reloadSession() {
    this.socket.adminReloadSession({ sessionId: this.sessionId })
    this.notifier.success("", {
      notificationId: `sessionReloaded${this.sessionId}`,
      title: `Reloaded session`,
      message: "That tab will now have reloaded",
      duration: 3000,
      type: "is-processing",
    })
    set(this, "canShowActionMenu", false)
  }

  @action reloadAllSessions() {
    this.socket.adminReloadAllSessions({ userId: this.model.id })
    this.notifier.success("", {
      notificationId: `sessionReloaded${this.model.id}`,
      title: `All sessions reloaded`,
      message: "All of the users's tabs will now have reloaded",
      duration: 3000,
      type: "is-processing",
    })
    set(this, "canShowActionMenu", false)
  }

  @action signOutAllSessions() {
    this.socket.adminSignOutAllSessions({ userId: this.model.id })
    this.notifier.success("", {
      notificationId: `userSignOut${this.model.id}`,
      title: `All the users sessions are now ended`,
      message: "They were signed out and redirected to the home screen.",
      duration: 3000,
      type: "is-processing",
    })
    set(this, "canShowActionMenu", false)
  }

  @action
  deleteUser(userId) {
    set(this, "canShowActionMenu", false)

    this.notifier.success("", {
      notificationId: `deleteUser${userId}`,
      title: `Deleting user...`,
      message: "You did it!",
      duration: 3000,
      type: "is-processing",
    })

    let doubleCheck = window.confirm("Are you sure you want to delete this user?")
    if (doubleCheck) {
      get(this, "rpc")
        .execute("user_delete", { userId: userId })
        .then(() => {
          let notification = _.find(get(this, "notifier.notifications"), {
            notificationId: "deleteUser${userId}",
          })

          if (notification) {
            set(notification, "title", "User Deleted!")
            set(notification, "type", "is-success")
          }
        })
    }
  }

  @action
  changeProduct(userId, newProductString) {
    set(this, "canShowActionMenu", false)

    let justChecking = window.confirm(
      `Are you sure you want to change the product to ${newProductString}?`
    )

    if (justChecking) {
      get(this, "rpc")
        .execute("user_change_product", { userId: userId, newProductString: newProductString })
        .then(() => {
          let notification = _.find(get(this, "notifier.notifications"), {
            notificationId: "changeProduct${newProductString}",
          })

          if (notification) {
            set(notification, "title", "Product Changed!")
            set(notification, "type", "is-success")
          }
        })
    }
  }
}
